export const listToString = (list: string[], andOrWord = "and") => {
  if (!list.length) return "";
  if (list.length === 1) return list[0];
  const lastItem = list.pop();
  return `${list.join(", ")} ${andOrWord} ${lastItem}`;
};
